// extracted by mini-css-extract-plugin
export default {"container":"uUlRk9","delay-length-input":"RR21ng","time-period-input":"AY9ZU4"};